import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
// =============================================================================
//  Copyright : 2018 semantics GmbH
//  Date      : $Date: 2026-01-31 22:57:43 +0100 (Sat, 31 Jan 2026) $
//  Author    : Dirk Rothe, Olli Powroznik
//  Worker    : $Author: d.rothe $
//  Revision  : $Rev: 160223 $
//  Purpose   : wiki parts
// =============================================================================
// ---Third-party imports
import React from 'react';
// ---Framework imports
import { funcPart, loadLazy as ll, loadLazyPart } from 'uix/parts';
import { XMenu } from 'uix/components';
// ---Local imports
import { WikiPane } from '../render';
import { WikiAlternatives } from '../components';
// ---Globals
export const SimpleWikiList = loadLazyPart('SimpleWikiList', ()=>import(/* webpackChunkName: 'wiki' */ './simple'));
//~ export const WikiEditor = loadLazy(() => import(/* webpackChunkName: 'wiki' */ './editor'))
export { WikiEditor } from './editor';
export const WikiHistory = ll(()=>import(/* webpackChunkName: 'wiki' */ './history'));
export const Wikiblock = funcPart(({ wiki, go, partcfg })=>{
    let { showMenu = false, showAlternatives = false } = partcfg;
    if (!wiki) {
        return null;
    }
    let editParams = wiki.otid ? {
        id: wiki.otid
    } : {
        query: {
            identifier: wiki.identifier
        }
    };
    let editWiki = ()=>go({
            classname: 'xwiki',
            tabname: 'edit',
            ...editParams
        });
    let menu = /*#__PURE__*/ _jsx(XMenu, {
        floated: "right",
        padded: true,
        children: /*#__PURE__*/ _jsx(XMenu.Item, {
            icon: "edit",
            onClick: editWiki
        })
    });
    let style = showAlternatives ? {
        flex: 1,
        overflow: 'auto'
    } : {};
    return /*#__PURE__*/ _jsxs(_Fragment, {
        children: [
            /*#__PURE__*/ _jsxs("div", {
                className: "wikiblock",
                style: style,
                children: [
                    showMenu && menu,
                    wiki.missing ? null : /*#__PURE__*/ _jsx(WikiPane, {
                        rendered: wiki.rendered,
                        identifier: wiki.identifier,
                        otid: wiki.otid
                    })
                ]
            }),
            showAlternatives && /*#__PURE__*/ _jsx(WikiAlternatives, {})
        ]
    });
});
export const WikiSearch = ll(()=>import(/* webpackChunkName: 'wiki' */ './search'));
